// extracted by mini-css-extract-plugin
export default {"label":"PriorityCell_label__1INv2"};